// extracted by mini-css-extract-plugin
export default {"title":"ControlSettings_title__a2DIT"};